<div class="sum-items-container">
    <!-- <span class="text">{{ 'aumico_notes_super_table_add_calculation_title_placeholder' | i18next }}</span>

    <input
        hamInput
        [formControl]="titleControl"
        [placeholder]="'aumico_notes_super_table_text_value_placeholder' | i18next"
    /> -->

    <div class="column-selection-container">
        <div class="item-selection">
            <input
                hamSimpleDropDown
                [options]="nameIdColSelections"
                [optionKeys]="['name']"
                [formControl]="xItemControl"
                returnKey="id"
                [allowFreeText]="false"
                [returnObject]="true"
                placeholder="{{ 'aumico_notes_super_table_enter_here' | i18next }}"
                [multiple]="false"
            />
            <span *ngIf="xItemControl.value == null" class="label">{{
                'aumico_notes_super_table_select_subtraction_column_mineund' | i18next
            }}</span>

            <div *ngIf="xItemControl.value" class="selected-items">
                <span class="chip">
                    {{ xItemControl.value.name }} <span class="remove-icon" (click)="removeXItem()">×</span>
                </span>
            </div>
        </div>
        <span class="subtraction-icon"> - </span>

        <div class="item-selection">
            <input
                hamSimpleDropDown
                [options]="nameIdColSelections"
                [optionKeys]="['name']"
                [formControl]="yItemControl"
                returnKey="id"
                [allowFreeText]="false"
                [returnObject]="true"
                placeholder="{{ 'aumico_notes_super_table_enter_here' | i18next }}"
                [multiple]="false"
            />
            <span *ngIf="yItemControl.value == null" class="label">{{
                'aumico_notes_super_table_select_subtraction_column_subtrahend' | i18next
            }}</span>
            <div *ngIf="yItemControl.value" class="selected-items">
                <span class="chip">
                    {{ yItemControl.value.name }} <span class="remove-icon" (click)="removeYItem()">×</span>
                </span>
            </div>
        </div>
    </div>

    <div>
        <span class="text">{{ 'aumico_notes_super_table_add_column_width' | i18next }}</span>
        <input
            placeholder="{{ 'aumico_notes_super_table_enter_here' | i18next }}"
            [options]="columnWidthSelections"
            hamSimpleDropDown
            [optionKeys]="['name']"
            returnKey="id"
            [multiple]="false"
            [formControl]="columnWidthControl"
        />
    </div>

    <div class="belonging-year-container">
        <span class="text">{{ 'aumico_notes_super_table_add_free_column_belonging_year' | i18next }}</span>
        <input
            hamSimpleDropDown
            [options]="belongingYearSelections"
            [optionKeys]="['name']"
            returnKey="id"
            [allowFreeText]="false"
            [placeholder]="'aumico_notes_super_table_add_free_column_belonging_year' | i18next"
            [multiple]="false"
            [formControl]="belongingYearControl"
        />
    </div>
</div>
